import React, { Component } from 'react';
import { Modal } from 'antd-mobile';
import { onWrapTouchStart, getProxyConfig } from '@/utils/utils';
import { ApiGetAwardPoolInfo, ApiSubmitAwardInfo } from '@/api/index';
import { AwardId2ImgMap, ImgPosMap, getLuckType, getHasLuckMsg, sign, getValueTime } from './config'; // getLuckType
import { Toast } from 'antd-mobile';
import dayjs from "dayjs";
import PrizeMsg from '../map'
// 当前页面cdn地址

class LuckyDraws extends Component {
  constructor(props) {
    super(props);
    this.luckyRef = React.createRef()

    // 屏幕可见高度
    const W = document.documentElement.clientWidth
    // 新组件
    const width = (W - 15 * 2) || 300

    this.state = {
      // 奖品配置
      prizes: [],
      width: (width < 300 ? 300 : width),
      height: (width < 300 ? 300 : width),

      modalShow: false,
      awardCount: 0,
      loading: false,
      localLucky: null, // 当前抽中的对象 如果为null则是规则弹框 否则其他的弹框会带有对应id
      lotteryList: [],

      stopIndex: 8, // 默认给一个没有的值
      speed: 0, // 默认最快0ms 最慢停下来500ms
      speedIndex: 8, // 转盘当前的亮

      activityDate: '',
    }
  }

  // 尼日的抽奖详情页面和肯尼亚一致 故直接使用kenya的cdn
  urlRoot = window.$localCdnLink + (PrizeMsg[this.props.app] && PrizeMsg[this.props.app].imgUrl) || PrizeMsg['default'].imgUrl;
  
  saMonitor (name, data) {
    this.props.SaSdk.track(name, data);
  }

  /** 添加权重进行抽奖
   * 生成100个数据(抽奖总和有100，把各自的概率填满)
   */
  lottery () {
    // 异步抽奖
    setTimeout(() => {
      const { app } = this.props;
      // 尼日利亚最小为0.01，概率要多乘以100
      const result = ['xcredit','imoney','ipesa','kashway'].includes(app) ? Math.random() * 100 * 100 : Math.random() * 100
      const { lotteryList } = this.state;
      const index =  result >> 0;
      this.setState({
        stopIndex: lotteryList[index]
      })
    }, 800)
  }

  emit () {
    // 回调抽奖次数
    const { awardCount, activityDate } = this.state
    this.props.onAwardCount(awardCount, activityDate);
  }

  getPoolInfo () {
    const { app, appRules, appData } = this.props;

    const lowerApp = app.toLowerCase();
    ApiGetAwardPoolInfo({
      headers: {
        ...appRules.header,
        ...appData,
      },
      data: {
        appId: appRules.appName,
      },
      ...getProxyConfig(app),
    }).then(res => {
      const { currentDate } = res // 当前日期
      const list = res.awardTurntableConfigList || []
      const [prizes, lottery] = [[], []];
      list.forEach(_ => {
        // 可配置到config中
        const { awardId, turntablePosition, awardRatio, couponValidDays } = _;
        const index = turntablePosition - 1;
        const imgAndTxt = AwardId2ImgMap[lowerApp][awardId];
        const lowerDecimal = { // 控制概率
          'ipeso': awardRatio,
          'xfectivo': awardRatio,
          'xcredit': awardRatio*100, // 最小量级为0.01
          'imoney': awardRatio*100,
          'ipesa': awardRatio*100, // 最小量级为0.01
          'kashway': awardRatio*100,
        }
        const awardRatioType = lowerDecimal[app] ||  awardRatio
        for(let i = 0; i < awardRatioType; i++) { // 后端已转成整数
          lottery.push(index)
        }
        const getImgText = {
          1002: 'charge adapter', // 充电宝
        }
        const imgText = getImgText[awardId] || (`${ sign[app]}${ imgAndTxt.text }` || `${ imgAndTxt.text }`) // 中奖弹窗金额
        prizes.push({
          ..._,
          index,
          couponValidDays,
          currentDate,
          bgImg: `${ this.urlRoot }/${ imgAndTxt.img }.webp`,
          name: imgText,
          activityStartDate: res.activityStartDate,
          activityEndDate: res.activityEndDate,
        })
      })
      const defaultTime = res.activityStartDate + ' - ' + res.activityEndDate
      const ngLuckTime = res.activityStartDate + ' to ' + res.activityEndDate
      const mxLuckTime = dayjs(res.activityStartDate).format('DD-MM-YYYY') + ' - ' + dayjs(res.activityEndDate).format('DD-MM-YYYY')
      const luckTimeType = {
        'ipeso': mxLuckTime,
        'xfectivo': mxLuckTime,
        'imoney': ngLuckTime,
        'xcredit': ngLuckTime,
        'ipesa': ngLuckTime,
        'kashway': ngLuckTime,
      }
      // const activityDate = ['ipeso','xfectivo'].includes(lowerApp) ?  mxLuckTime : defaultTime
      const activityDate = luckTimeType[lowerApp] || defaultTime

      this.setState({
        prizes: prizes.sort((a, b) =>{ return (a.index - b.index) }).map(_=> {
          const [x, y] = ImgPosMap[_.index];
          return { ..._, x, y };
        }),
        awardCount: res.awardCount || 0,
        lotteryList: lottery,
        activityDate: activityDate
      })
    }).finally(() => {
      this.emit();
    })
  }

  startSp () {
    this.saMonitor('h5_lucky_draws_play');
    const { awardCount } = this.state; // 当前抽奖次数
    if (awardCount <= 0) {
      this.setState({
        modalShow: true,
        localLucky: null,
      })
      return
    }

    // 做过滤 防止多点
    if (this.state.loading) return
    this.setState({ loading: true })

    let waitLucky = (PrizeMsg[this.props.app] && PrizeMsg[this.props.app].waitLucky) || PrizeMsg['default'].waitLucky;
    Toast.info(waitLucky, 2);

    this.setState({
      speedTime: 0,
      speedIndex: 8,
    })
    this.aniSpeed()
    this.lottery()
  }

  aniSpeed (speed = 0) {
    const { speedIndex, stopIndex } = this.state

    // 最慢
    if (speed === 2000) {
      if(speedIndex === stopIndex) {
        this.stopLuck();
        return
      }
    } else {
      this.setState({ speedTime: speed + 50 })
    }

    let index = speedIndex > 7 ? -1 : speedIndex; // -1 + 1 = 0从0开始
    this.setState({ speedIndex: index + 1 })

    setTimeout(() => {
      this.aniSpeed(this.state.speedTime)
    }, this.state.speedTime / 20) // 直接使用speedTime后面太慢了
  }

  stopLuck () {
    const { stopIndex } = this.state
    const p = this.state.prizes.find(_ => _.index === stopIndex)
    this.setState({
      modalShow: true,
      localLucky: p,
    })

    const { awardId } = p;
    const { app, appRules, appData } = this.props;
    // 就算未中奖也提交 次数-1
    ApiSubmitAwardInfo({
      headers: {
        ...appRules.header,
        ...appData,
      },
      data: {
        appId: appRules.appName,
        awardId: awardId
      },
      ...getProxyConfig(app),
    }).then(res => {
      this.setState({ awardCount: res.remainCount || 0 })
    }).finally(() => {
      this.emit();
      this.setState({ loading: false })
    })
  }

  componentDidMount(){
    this.getPoolInfo();
  }
  render() {
    const { localLucky } = this.state;

    const { app, appRules } = this.props;
    const lowerApp = app.toLowerCase();
    let modalClassName = 'draws-modal ' + app;
    // country
    let modalTitle =  ( PrizeMsg[app] && PrizeMsg[app].numNote ) || PrizeMsg['default'].numNote;
    const count = appRules.country === 'KE' ||  appRules.country === 'MX' ? 2 : 3;
    let modalContent = (PrizeMsg[app] && PrizeMsg[app].modelContent(count)) || PrizeMsg['default'].modelContent(count);
    let modelId = 'noChance'
    
    // 非null
    if (localLucky) {
      const { awardId, awardDesc, name, couponValidDays} = localLucky;
      const _class = `l${ awardId } luck-box`
      modelId = `md${ awardId }`
      if (awardId === 4001 || awardId === 4002) {
        modalTitle = ( PrizeMsg[app] && PrizeMsg[app].noPrize ) || PrizeMsg['default'].noPrize;
        modalContent = ( PrizeMsg[app] && PrizeMsg[app].noPrizeModelContent(_class,this.urlRoot) ) || PrizeMsg['default'].noPrizeModelContent(_class,this.urlRoot);
      } else {
        modalClassName = modalClassName + ' award-lucks';
        const award = AwardId2ImgMap[lowerApp][awardId];
        // const bg = `${ this.urlRoot }/${ award.img }.webp`
        const bgClass = `${ this.urlRoot }/luck-${ award.img }.webp`
        const powerAndCharge = `${ this.urlRoot }/${ award.img }.webp` // 话费，充电宝图片

        const activityEndDate = getValueTime(couponValidDays, lowerApp)

        const HasLuckMsg = getHasLuckMsg[app][award.img]
        const prizeTypeMsg = getLuckType[app](awardId,name) 
        modalTitle = (PrizeMsg[app] && PrizeMsg[app].hasPrize) || PrizeMsg['default'].hasPrize;
        const getModalContent = {
          'default': (PrizeMsg[app] && PrizeMsg[app].hasPrizeModelContent(_class, awardId, HasLuckMsg, bgClass, prizeTypeMsg, award, activityEndDate,sign[app])) || PrizeMsg['default'].hasPrizeModelContent(_class, awardId, HasLuckMsg, bgClass, awardDesc, award, activityEndDate,sign[app]),
          2001: (PrizeMsg[app] && PrizeMsg[app].powerPrizeModelContent(_class, awardId, powerAndCharge, prizeTypeMsg)) || PrizeMsg['default'].powerPrizeModelContent(_class, awardId, powerAndCharge, awardDesc), // 话费
          1002: (PrizeMsg[app] && PrizeMsg[app].powerPrizeModelContent(_class, awardId, powerAndCharge, prizeTypeMsg, 1.2, 1.9)) || PrizeMsg['default'].powerPrizeModelContent(_class, awardId, powerAndCharge, awardDesc, 1.2, 1.9), // 充电宝
        }
        modalContent = getModalContent[awardId] || getModalContent['default']
      }
    }

    const { prizes, width, speedIndex, stopIndex, speedTime } = this.state;

    const luck = prizes.map(_=> {
      const { index, x, y, awardId } = _

      let _c = `item l${ awardId }`;
      if (speedIndex === index || (speedTime === 0 && stopIndex === index)) {
        _c += ' active';
      }
      // width: priceWidth,
      // height: priceWidth,
      return <div className={_c} key={ index }
        style={{
          width: '33.33%',
          height: '33.33%',
          top: `${(y * 33.33)}%`,
          left: `${(x * 33.33)}%`,
        }}
      >
        <div className='item-main'>
          <div className='item-bg'
            style={{
              backgroundImage: `url(${ _.bgImg })`,
            }}
          >
            <span className="item-name">{ _.name || '' }</span>
          </div>
          <p className='item-label' style={{wordBreak: 'break-word'}}>{ _.awardDesc }</p>
        </div>
      </div>
    })
    //width + 'px'
    return <div className="draws-areas-content" style={{
      width: '100%',
      height: width + 'px',
    }}>
      <Modal
        className={ modelId }
        wrapClassName={ modalClassName }
        visible={ this.state.modalShow }
        closable={false}
        maskClosable={true}
        transparent
        onClose={()=> this.setState({ modalShow: false }) }
        title={ modalTitle }
        footer={[{ text: 'OK', onPress: () => { this.setState({ modalShow: false }) } }]}
        wrapProps={{ onTouchStart: onWrapTouchStart }}
      >
        <div dangerouslySetInnerHTML = {{ __html:modalContent }}></div>
      </Modal>
      {/* width: priceWidth,
            height: priceWidth, */}
      <div className={ lowerApp + " draws-main" }>
        {/* 抽奖 */}
        <div className='item start' onClick={()=> this.startSp() }
          style={{
            width: '33.33%',
            height: '33.33%',
          }}
        >
          <div className='item-main'>
            <div className='item-bg'
              id="center-go"
              style={{
                backgroundImage: `url(${ window.$localCdnLink + '/webp/go.webp' })`
              }}
            >
            </div>
          </div>
        </div>
        { luck }
      </div>
    </div>
  }
}

export default LuckyDraws;
